var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9669 4.97998C6.84023 4.97998 6.71355 4.93333 6.61355 4.83333L4.48688 2.70667L2.36021 4.83333C2.16688 5.02667 1.84688 5.02667 1.65354 4.83333C1.46021 4.64 1.46021 4.32 1.65354 4.12667L4.13357 1.64665C4.2269 1.55331 4.35355 1.5 4.48688 1.5C4.62021 1.5 4.7469 1.55331 4.84023 1.64665L7.32021 4.12667C7.51355 4.32 7.51355 4.64 7.32021 4.83333C7.22021 4.93333 7.09357 4.97998 6.9669 4.97998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48657 14.5C4.21324 14.5 3.98657 14.2733 3.98657 14V2C3.98657 1.72667 4.21324 1.5 4.48657 1.5C4.75991 1.5 4.98657 1.72667 4.98657 2V14C4.98657 14.2733 4.75991 14.5 4.48657 14.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5201 14.5C11.3867 14.5 11.2601 14.4467 11.1667 14.3534L8.68675 11.8733C8.49341 11.68 8.49341 11.36 8.68675 11.1667C8.88008 10.9733 9.20008 10.9733 9.39341 11.1667L11.5201 13.2933L13.6467 11.1667C13.84 10.9733 14.1601 10.9733 14.3534 11.1667C14.5467 11.36 14.5467 11.68 14.3534 11.8733L11.8734 14.3534C11.7801 14.4467 11.6467 14.5 11.5201 14.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5134 14.5C11.2401 14.5 11.0134 14.2733 11.0134 14V2C11.0134 1.72667 11.2401 1.5 11.5134 1.5C11.7868 1.5 12.0134 1.72667 12.0134 2V14C12.0134 14.2733 11.7934 14.5 11.5134 14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListing);
export default __webpack_public_path__ + "static/media/listing.3bf201bfe446a966e598d957baeaae63.svg";
export { ForwardRef as ReactComponent };